export enum UserRole {
  owner = 'owner',
  admin = 'admin',
  deviceManager = 'device-manager',
  contentManager = 'content-manager',
  viewer = 'viewer'
}
